import { render, staticRenderFns } from "./MeasureTransfer.vue?vue&type=template&id=4ccf40ca&"
import script from "./MeasureTransfer.vue?vue&type=script&lang=js&"
export * from "./MeasureTransfer.vue?vue&type=script&lang=js&"
import style0 from "./MeasureTransfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports